import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";

const PERCENT = 100;

/** Rate of Change (research §1.4), as TV Rate Of Change: the change of the close over Period bars in percent. */
export default {
  id: "rate-of-change",
  name: "Rate of Change",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 14, { max: 100 }),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.YELLOW),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    for (let index = fromIndex; index < bars.length; index += 1) {
      const pastClose = index >= period ? bars[index - period].close : NaN;

      series.value[index] = (PERCENT * (bars[index].close - pastClose)) / pastClose;
    }
  },
};
